import { AppConfig, defaultConfig } from '../config';

let resolved: AppConfig | null = null;

/**
 * Loads runtime config from the server-side endpoint /assets/config/config.json,
 * merges it with the compile-time defaults, and caches the result. In dev mode
 * (no config.json available) it falls back to the localhost api.
 */
export async function loadRuntimeConfig(): Promise<AppConfig> {
  if (resolved) {
    return resolved;
  }

  let serverConfig: Partial<AppConfig> = {};

  try {
    const response = await fetch('/assets/config/config.json', {cache: 'no-store'});
    if (response.ok) {
      serverConfig = await response.json();
    }
  } catch (error) {
    console.warn('no runtime config available, using defaults', error);
  }

  resolved = mergeConfig(defaultConfig, serverConfig);

  if (!resolved.apis.baseUri) {
    resolved.apis.baseUri = `${location.protocol}//${location.hostname}:9999`;
  }

  return resolved;
}

/**
 * Returns the cached runtime config. Throws when called before loadRuntimeConfig().
 */
export function getConfig(): AppConfig {
  if (!resolved) {
    throw new Error('runtime config not loaded yet');
  }
  return resolved;
}

function mergeConfig(base: AppConfig, override: Partial<AppConfig>): AppConfig {
  return {
    name: override.name || base.name,
    tenantId: typeof override.tenantId === 'number' ? override.tenantId : base.tenantId,
    apis: {
      baseUri: (override.apis && override.apis.baseUri) || base.apis.baseUri
    },
    mfa: {
      issuer: (override.mfa && override.mfa.issuer) || base.mfa.issuer
    }
  };
}
